import request from '../../api/request';

import {
  CreditLiquidationFormDataResponse,
  CreditLiquidationFilter,
  LiquidationPreviewResponse,
  ExecuteLiquidationRequest,
  ExecuteLiquidationResponse,
  UpdateCreditsRequest,
  UpdateCreditsResponse,
  LiquidationVersionSummary,
} from './types';

const CREDIT_LIQUIDATION = {
  FORM_DATA: '/maintainers-portal/credit-liquidation/form',
  PREVIEW: '/maintainers-portal/credit-liquidation/preview',
  EXECUTE: '/maintainers-portal/credit-liquidation/execute',
  UPDATE_CREDITS: '/maintainers-portal/credit-liquidation/credits',
  HISTORY: '/maintainers-portal/credit-liquidation/history',
  LATEST_VERSION: '/maintainers-portal/credit-liquidation/latest-version',
  EXPORT: '/maintainers-portal/credit-liquidation/export',
};

export function getCreditLiquidationFormData() {
  return request<CreditLiquidationFormDataResponse>(CREDIT_LIQUIDATION.FORM_DATA);
}

export function getCreditLiquidationPreview(params: CreditLiquidationFilter) {
  return request<LiquidationPreviewResponse>(CREDIT_LIQUIDATION.PREVIEW, {
    params,
  });
}

export function executeCreditLiquidation(data: ExecuteLiquidationRequest) {
  return request<ExecuteLiquidationResponse>(CREDIT_LIQUIDATION.EXECUTE, {
    method: 'POST',
    data,
  });
}

export function updateStudentCredits(data: UpdateCreditsRequest) {
  return request<UpdateCreditsResponse>(CREDIT_LIQUIDATION.UPDATE_CREDITS, {
    method: 'PATCH',
    data,
  });
}

export function getLiquidationHistory(periodId: number) {
  return request<LiquidationVersionSummary[]>(CREDIT_LIQUIDATION.HISTORY, {
    params: { periodId },
  });
}

export function getLatestLiquidationVersion(periodId: number) {
  return request<LiquidationVersionSummary | null>(CREDIT_LIQUIDATION.LATEST_VERSION, {
    params: { periodId },
  });
}

export async function downloadLiquidationExcel(periodId: number) {
  const response = await request<Blob>(CREDIT_LIQUIDATION.EXPORT, {
    params: { periodId },
    responseType: 'blob',
  });

  if (response.error) {
    throw new Error('Error al descargar el archivo');
  }

  // Crear blob y descargar
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `liquidacion-creditos-periodo-${periodId}.xlsx`);
  link.click();
  window.URL.revokeObjectURL(url);
}

export async function downloadVersionExcel(versionId: number, periodId: number) {
  const response = await request<Blob>(
    `${CREDIT_LIQUIDATION.HISTORY}/${versionId}/download`,
    {
      params: { periodId },
      responseType: 'blob',
    },
  );

  if (response.error) {
    throw new Error('Error al descargar el archivo');
  }

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `liquidacion-creditos-version-${versionId}.xlsx`);
  link.click();
  window.URL.revokeObjectURL(url);
}
